import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-building-side-selector',
  templateUrl: './building-side-selector.component.html',
  styleUrls: ['./building-side-selector.component.scss']
})
export class BuildingSideSelectorComponent implements OnInit {

  @Input() parentForm: FormGroup;
  @Input() buildingSide: string;
  sides: string[] = [
    "FRONT", "LEFT", "RIGHT", "BEHIND",
  ];

  constructor() { }

  ngOnInit() {
  }

}
